import { useEffect } from 'react';

/**
 * Parsing program data, extracting images and return prioritized list
 *
 * @param {Array} entries
 * @returns Array of image objects
 */
function getImages(entries) {
  let images = [];

  // Prioritizes preloading of top images
  entries.forEach(({ image, video, thumb }) => {
    if (image) {
      images = [...images, image.img];
    }
    if (video && video.picture && video.picture.img) {
      images = [...images, video.picture.img];
    }

    if (thumb && thumb.img) {
      images = [...images, thumb.img];
    }
  });

  // Preloading content images
  entries.forEach(({ content }) => {
    if (content) {
      content.forEach(({ image, pages, videos, video, picture, slides }) => {
        if (image) {
          images = [...images, image.img];
        }

        if (pages) {
          pages.forEach(({ image: { img, sources } }) => {
            images = [...images, img];
            sources.forEach(img => {
              images = [...images, img];
            });
          });
        }

        if (videos) {
          videos.forEach(({ thumb, video }) => {
            if (thumb && thumb.img) {
              images = [...images, thumb.img];
            }

            if (video && video.picture && video.picture.img) {
              images = [...images, video.picture.img];
            }
          });
        }

        if (video && video.picture && video.picture.img) {
          images = [...images, video.picture.img];
        }

        if (picture && picture.img) {
          images = [...images, picture.img];
        }

        if (slides) {
          slides.forEach(({ image: { img } }) => {
            images = [...images, img];
          });
        }
      });
    }
  });

  return images;
}

/**
 *  Creates an image preload link, adds it to html head and returns the node
 *
 * @param Object image
 * @returns Node preload image link;
 */
function createAndAddLink({ srcSet, sizes, media }) {
  const headID = document.getElementsByTagName('head')[0];

  const t = document.createElement('template');
  if (media) {
    t.innerHTML = `<link rel="preload" as="image" imagesrcset="${srcSet}" imagesizes="${sizes}" media="${media}" />`;
  } else {
    t.innerHTML = `<link rel="preload" as="image" imagesrcset="${srcSet}" imagesizes="${sizes}" />`;
  }

  const link = t.content.cloneNode(true);
  headID.appendChild(link);

  return link;
}

/**
 * When program data is loded, parse all data and add image preload links to html head
 *
 * @param Object data
 */
export default data => {
  useEffect(() => {
    const { entries } = {
      entries: [],
      ...data,
    };

    const links = getImages(entries).map(createAndAddLink);

    return () => {
      links.forEach(node => {
        if (node.parentNode) {
          node.parentNode.removeChild(node);
        }
      });
    };
  }, [data]);
};
